export const BACKGROUND_STATE = {
  INTRO: 0,
  NORMAL: 1,
  CLEAN: 2,
};
